import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@mui/material';

import { Statistic, getValue } from './Statistics';

export default function PortfolioStatistics({ statistics }: { statistics: Statistic[] }) {
  return (
    <div className="my-8">
      <dl className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {statistics.map(stat => (
          <div
            key={stat.label}
            className="flex flex-col px-3 py-4 border-2 border-gray-300 rounded-2xl"
          >
            <dt className="flex items-center gap-1 mt-2">
              {(stat?.label?.length || 0) > 25 ? (
                <Tooltip title={stat.label} placement="top">
                  <p className="text-xs font-semibold text-gray-600 leading-tight truncate">
                    {stat.label}
                  </p>
                </Tooltip>
              ) : (
                <p className="text-xs font-semibold text-gray-600 leading-tight truncate">
                  {stat.label}
                </p>
              )}
              {stat.helperText && (
                <Tooltip title={stat.helperText} placement="right">
                  <InformationCircleIcon className="h-4 w-4 text-gray-600" />
                </Tooltip>
              )}
            </dt>
            <dd className="order-first text-gray-900 whitespace-nowrap w-full">
              <p className="text-xl font-semibold tracking-tight text-left w-full text-gray-900 whitespace-nowrap">
                {getValue(stat.value, stat.type, stat.navigateTo, stat.customValue)}
              </p>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
